/**
 * Vuex store module for E-Care (Metabase analytics) integration.
 *
 * @module store/modules/ecare
 * @description Manages state for Metabase dashboard integration, including dashboard list,
 * tab selection, and editor visibility. Provides access to embedded analytics dashboards
 * for customer care insights.
 *
 * @example
 * // Access state
 * this.$store.state.ecare.dashboards
 *
 * // Dispatch action
 * this.$store.dispatch('ECARE_GET_DASHBOARDS')
 *
 * // Toggle editor
 * this.$store.dispatch('ECARE_TOGGLE_EDITOR_VISIBLE')
 */
import actions from "./actions";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { EcareState } from "./types";
import { RootState } from "@/store/types";

const ecare: Module<EcareState, RootState> = {
  // namespaced: true,
  actions,
  mutations,
  state,
};

export default ecare;
